import { InsertRowBelowIcon } from '@databases/icons';
import { messages } from '@databases/intl/messages';
import { SHORTCUTS, tooltip } from '@databases/keyboard-shortcuts';
import React from 'react';

import { submenu } from '../../../select-value-menu/state/submenu-state.ts';
import { SELECT_VALUE_MENU_ACTIONS } from '../../../select-value-menu/types.ts';
import { type SelectionsEffectMenuItemBuilder } from '../types.ts';

export const addEntryBelowMenuItem: SelectionsEffectMenuItemBuilder = (
  context,
  actions,
  skip
) => {
  if (!context.capabilities.canInsertContent) {
    return skip;
  }

  return () => ({
    key: SELECT_VALUE_MENU_ACTIONS.ADD_ENTRY_BELOW,
    content: context.formatMessage(messages['entry-actions.add-below']),
    onClick: () => {
      actions.row.handleInsertEntries('after', [context.entryId]);

      context.closeMenu();
    },
    onMouseEnter: submenu.close,
    elemAfter: <>{tooltip(SHORTCUTS.ADD_ENTRY_BELOW.keyMap)}</>,
    keyboardShortcut: SHORTCUTS.ADD_ENTRY_BELOW.keyboardShortCut,
    elemBefore: <InsertRowBelowIcon label="" />
  });
};
